// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__1Pd_H","error":"Notification_error__1lohP","success":"Notification_success__2gV4n"};